import { render, staticRenderFns } from "./VehicleMarketValue.vue?vue&type=template&id=7bf654c3&"
import script from "./VehicleMarketValue.vue?vue&type=script&lang=js&"
export * from "./VehicleMarketValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports